import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import axios from 'axios';
import { getSessionId, getReferrerUrl, getSinglePageSessionId } from './utils';
var LOG_ENDPOINT = 'https://bandar-logger.prezi.com/log/json';
export function logGlassbox(logMessage) {
  var requestFromPreprod = window.location.hostname.indexOf('preprod') > -1;
  var requestFromLocal = window.location.hostname.indexOf('localhost') > -1;
  var requestFromPde = window.location.hostname.indexOf('.prezi.dev') > -1;

  if (requestFromPreprod || requestFromLocal || requestFromPde) {
    var _process, _process$env;

    var runByTest = ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'test';

    if (!runByTest) {
      console.log('glassbox', logMessage.core.event_type, JSON.stringify(logMessage));
    }

    return Promise.resolve(true);
  } else {
    if (window.navigator && window.navigator.sendBeacon) {
      return Promise.resolve(navigator.sendBeacon(LOG_ENDPOINT, JSON.stringify([logMessage])));
    } else {
      return axios.post(LOG_ENDPOINT, [logMessage], {
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'json',
        timeout: 20000,
        withCredentials: true
      }).then(function () {
        return true;
      }).catch(function () {
        return false;
      });
    }
  }
}
export function buildGlassboxPayload(type, schemaId, eventSource, eventType, eventName, params) {
  return {
    core: {
      type,
      schema_id: schemaId,
      client_time: new Date().getTime(),
      event_source: eventSource,
      event_type: eventType
    },
    event_source: {
      single_page_session_id: getSinglePageSessionId()
    },
    platform: {
      type: 'Web',
      referer: getReferrerUrl()
    },
    user: {
      session_id: getSessionId()
    },
    body: _objectSpread({
      event_name: eventName
    }, params)
  };
}